module.exports = __webpack_public_path__ + "static/Milan_Misak_Tak-b33106323b45cd47ea99aee9ad57c9b9.mp3";